import React from 'react';
import {Link} from "react-scroll";
//Image... 
import HeaderImg from '../images/MechanicDiagnostics.jpg'

export const Hero = () => {
    return (
        <main>
            <section className='hero-section' id='hero' style={{backgroundImage: `url(${HeaderImg})`}}>
                <div className='hero-overlay'>
                    <div className='section-content'>
                        <div className='hero-details'>
                            <h1 className='title'>
                                Your Trusted Auto Repair Shop in Phoenix.
                            </h1>

                            <p className='description'>
                            At A to Z Auto Repair Center, we're committed to providing reliable, high-quality automotive repair and maintenance services you can trust. Our experienced technicians deliver honest recommendations, quality workmanship, and dependable repairs to keep your vehicle running at its best. We proudly serve both English and Spanish-speaking customers. ¡Se habla español!
                            </p>
                            
                            <div className='buttons'>
                                <Link activeClass='active' to='contact' spy={true} smooth={true} offset={-90} duration={500} className='button primary-button'>
                                    Request an Estimate
                                </Link>
                                <Link activeClass='active' to='about' spy={true} smooth={true} offset={-90} duration={500} className='button secondary-button'>
                                    Learn More
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}
